import type { ChangelogEntry } from "../types";

/**
 * VIB-2720. Rapporter viste en mislykket spørring som en tom tabell.
 *
 * Seksjonen er `minRole: "admin"`, av samme grunn som i 2026-10-01-smoke-fikser:
 * `role_menu_permissions` gir bare admin og superadmin `rapporter`. Et punkt
 * uten rollekrav ville fortalt ansatte om en skjerm de ikke kan åpne.
 *
 * Denne oppføringen og smoke-fikser-oppføringen samme dag sier bevisst to
 * forskjellige ting: den sier at tallene er tilbake, denne sier at neste gang
 * de forsvinner, får du vite det.
 */
export const RAPPORTFEIL_2026_10: ChangelogEntry = {
  id: "2026-10-01-rapportfeil",
  date: "2026-10-01",
  title: "Rapporter sier fra når noe feiler",
  summary:
    "En rapport som ikke klarte å hente tallene så før ut som en rapport uten tall. Nå står det tydelig at noe gikk galt.",
  sections: [
    {
      heading: "Rapporter",
      minRole: "admin",
      items: [
        {
          title: "«Ingen data» betyr nå faktisk ingen data",
          kind: "forbedret",
          body: "Hvis tallene ikke kan hentes, får du en melding om at rapporten feilet, med den tekniske årsaken under. Før sto det bare «Ingen data», som er et helt troverdig svar når du ser på en rolig måned, og derfor kunne en ekte feil bli stående lenge uten at noen meldte fra. Ser du meldingen, er det ikke noe du har gjort feil: send den videre til Erik.",
        },
        {
          title: "Eksportknappen forsvinner når rapporten feiler",
          kind: "forbedret",
          body: "Da kan du ikke komme i skade for å laste ned en tom CSV og tro at den er fasiten.",
        },
      ],
    },
  ],
};
